import {IHttpService} from "angular";
import {ConsolidatedOrderDepthRecord} from "../../depth/types/OrderDepthRecord";
import {CodeAndExchange} from "../../instruments/types/CodeAndExchange";

export class DepthService {
    public static id = "depthService";

    /** @ngInject */
    constructor(private $http: IHttpService) {
    }

    public async load(security: CodeAndExchange): Promise<ConsolidatedOrderDepthRecord> {
        const path = `/tradefloor/api/price-depth/${security.code}/${security.exchange}`;
        const response = await this.$http.get<ConsolidatedOrderDepthRecord>(path, {ignoreLoadingBar : true});
        return response.data!;
    }
}
